function VehiclebookingsController() {
    this.constructor.apply(this, arguments);
}

VehiclebookingsController.$inject = ['$scope', '$state', 'VehicleBookingService', '$mdDialog', '$ionicScrollDelegate', '$stateParams', '$timeout', 'localStorageService', '$message', '$q', '$translationService', '$Loading', 'AuthService'];

VehiclebookingsController.prototype = {

    /**
     * @param $scope {angular.IScope}
     * @param $state {ui.IStateService}
     * @param VehicleBookingService {VehicleBookingService}
     * @param $mdDialog {$mdDialog}
     * @param $ionicScrollDelegate {$ionicScrollDelegate}
     * @param $stateParams {ui.IStateParamsService}
     * @param $timeout {ng.ITimeoutService}
     * @param localStorageService{localStorageService}
     * @param $message{$message}
     * @param $q {ng.IQService}
     * @param $translationService{$translationService}
     * @param {$Loading} $Loading - Loading service for showing/hiding loading indicators
     * @param {AuthService} AuthService - Service for authentication
     */
    constructor($scope, $state, VehicleBookingService, $mdDialog, $ionicScrollDelegate, $stateParams, $timeout, localStorageService, $message, $q, $translationService, $Loading, AuthService) {
        this.$scope = $scope;
        this.$state = $state;
        this.vehicleBookingService = VehicleBookingService;
        this.$mdDialog = $mdDialog;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.localStorageService = localStorageService;
        this.$message = $message;
        this.$q = $q;
        this.$translationService = $translationService;
        this.$Loading = $Loading;


        /** @type {IVehicleBooking[]} list - list of vehicle bookings */
        this.list =  [];

        /** number[] */
        this.timers = [];

        /** @type boolean */
        this.dataLoaded = false;


        /** @type  IAuthenticatedUser */
        this.authenticatedUser = AuthService.getAuthenticatedUser();
        this.$element = $('#internal-vehicle-bookings-page');
        this.addEvents();
        this.loadData().then(()=>{
            this.dataLoaded = true;
        });
    },
    addEvents() {
        this.$scope.$on('$destroy',  () => {
            // Close all dialog
            this.$mdDialog.cancel();
            
            // Cancel all timers
            for (let _i = 0, _a = this.timers; _i < _a.length; _i++) {
                let timer = _a[_i];
                this.$timeout.cancel(timer);
            }
        });
    },
    /**
     * Get my bookings
     * @returns {angular.IPromise<IVehicleBooking[]>}
     */
    getMyBookings() {
        return this.vehicleBookingService.getMyBookings().then((vehicleBookings) => {
            // Map vehicle bookings to IVehicleBooking[]

            // Map status
            if (vehicleBookings.PickedUp) {
                if (vehicleBookings.PickedUp.length > 0) {
                    vehicleBookings.PickedUp[0].isFirstItemOfGroup = true;
                    vehicleBookings.PickedUp[0].groupName = 'PickedUp';
                }
                vehicleBookings.PickedUp.forEach((booking) => {
                    booking.Status = 'PickedUp';
                })
            }
            if (vehicleBookings.Planned) {
                if (vehicleBookings.Planned.length > 0) {
                    vehicleBookings.Planned[0].isFirstItemOfGroup = true;
                    vehicleBookings.Planned[0].groupName = 'Planned';
                }
                vehicleBookings.Planned.forEach((booking) => {
                    booking.Status = 'Valid';
                })
            }
            if (vehicleBookings.Returned) {
                if (vehicleBookings.Returned.length > 0) {
                    vehicleBookings.Returned[0].isFirstItemOfGroup = true;
                    vehicleBookings.Returned[0].groupName = 'Returned';
                }
                vehicleBookings.Returned.forEach((booking) => {
                    booking.Status = 'Returned';
                })
            }
            /** @type IVehicleBooking[]  */
            let list = Array.prototype.concat(vehicleBookings.PickedUp, vehicleBookings.Planned, vehicleBookings.Returned);
            list.forEach((item) => {
                // Only for display 
                item.type = 'Customize';
                if (item.StartDate === item.EndDate) {
                    item.type = 'SameDay';
                    if (item.StartTime === '00:00' && item.EndTime === '23:59') {
                        item.type = 'FullDay';
                    }
                }
            })
            return list;
        });
    },

    /**
     * Goback to prev page
     */
    goBack() {
        this.$state.go("internal.home");
    },
    /**
     * Go to add vehicle booking page
     */
    gotoAddVehicleBooking() {
        this.$state.go('internal.addvehiclebooking');
    },
    /**
     * Show pickup modal
     * @param {IVehicleBooking} vehicleBooking
     * @param {MouseEvent} $event
     */
    showPickupModal(vehicleBooking, $event) {
        $event.stopImmediatePropagation();
        this.$state.go('internal.pickup', {
            id: vehicleBooking.Id,
            vehicleBooking: JSON.stringify(vehicleBooking),
            state: JSON.stringify({
                scrollTop: this.getScrollTop()
            })
        });
    },
    /**
     * Click on return button to return a bokking which is picked-up
     * @param {IVehicleBooking} vehicleBooking
     * @param {MouseEvent} $event
     */
    onReturnClicked(vehicleBooking, $event) {
        $event.stopImmediatePropagation();
        this.$state.go('internal.return', {
            id: vehicleBooking.Id,
            vehicleBooking: JSON.stringify(vehicleBooking),
            state: JSON.stringify({
                scrollTop: this.getScrollTop()
            })
        });
    },
    /**
     * Remove a booking
     * @param {IVehicleBooking} booking
     */
    removeBooking(booking) {
        this.vehicleBookingService.removeBooking(booking.Id).then(() => {
            let index = _.findIndex(this.list, {
                Id: booking.Id
            });
            if (index !== -1) {
                this.list.splice(index, 1);
            }
        }, this.$message.error);
    },
    /**
     * Click on delete button to delete a booking
     * @param {IVehicleBooking} vehicleBooking
     * @param {MouseEvent} $event
     */
    onDeleteClicked(vehicleBooking, $event) {
        $event.stopImmediatePropagation();
        let confirm = this.$mdDialog.confirm()
            .theme('custom-confirm')
            .clickOutsideToClose(true)
            .title(this.$translationService.getTranslation('DeleteVehicleBooking'))
            .htmlContent(this.$translationService.getTranslation('ConfirmDeleteDeleteVehicleBooking') + " <b>" + vehicleBooking.VehicleModel + "</b>")
            .targetEvent($event)
            .ok(this.$translationService.getTranslation('Yes'))
            .cancel(this.$translationService.getTranslation('No'));
        this.$mdDialog.show(confirm).then(() => {
            this.removeBooking(vehicleBooking);
        });
    },

    /**
     * Charge vehicle
     * @param {IVehicleBooking} vehicleBooking
     * @param {MouseEvent} $event
     */
    onChargeClicked(vehicleBooking, $event){
        $event.stopImmediatePropagation();
        let params = {
            context:"vehiclebooking",
            contextId: vehicleBooking.Id,
            state: JSON.stringify({
                stateName: 'internal.vehiclebookings',
                scrollTop: this.getScrollTop()
            })
        }
        this.$state.go('internal.chargingrequest', params);
    },
    /**
     * Click on booking to go booking page
     * @param {IVehicleBooking} item
     */
    onBookingItemClicked(item) {
        this.$state.go('internal.booking-details', {
            id: item.Id,
            prevState: 'internal.vehiclebookings',
            state: JSON.stringify({
                stateName: 'internal.vehiclebookings',
                scrollTop: this.getScrollTop()
            })
        });
    },
    /**
     * Show guide modal
     * @param {number} width
     * @param {Function} complete
     */
    showGuideModal(width, complete) {
        let scope = this.$scope.$new(true);
        scope.right = width + 20;
        this.$mdDialog.show({
            templateUrl: 'js/internal/vehiclebookings/booking-list/guide.html',
            clickOutsideToClose: true,
            escapeToClose: true,
            scope: scope
        }).finally(function () {
            if (complete)
                complete();
        });
    },
    /**
     * Show guide to use this page
     * @returns {angular.IPromise<any>}
     */
    showGuidAnimation() {
        return this.$q((resolve) => {
            let item = this.$element.find('ion-item:first'), itemOptions = item.find('.item-options'),
                itemContent = item.find('.item-content'), optionsWidth = itemOptions.width();
            itemOptions.removeClass('invisible');
            itemContent.css('transform', 'translate3d(-' + optionsWidth + 'px, 0px, 0px)');
            let timer = this.$timeout(500);
            this.timers.push(timer);
            timer.then(() => {
                this.showGuideModal(optionsWidth, () => {
                    resolve();
                });
            });
        });
    },
    safeApply(fn) {
        let phase = this.$scope.$root.$$phase;
        if (phase === '$apply' || phase === '$digest') {
            if (fn && (typeof (fn) === 'function')) {
                fn();
            }
        } else {
            this.$scope.$apply(fn);
        }
    },
    /**
     * Scroll to top
     * @returns {any}
     */
    getScrollTop() {
        return this.$ionicScrollDelegate.$getByHandle('vehicle-bookings-scroller-handle').getScrollPosition().top;
    },



    /**
     * Show guide if user hasn't yet show guide
     * @param vehicleBookings{IVehicleBooking[]}
     */
    showGuide(vehicleBookings) {
        this.list = [{
            'Id': 'iiiii',
            'VehicleModel': 'BMW 225xe Active Tourer (2016)',
            'VehicleName': '1-SFK-461',
            'StartDate': '2018-08-06',
            'StartTime': '00:00',
            'EndDate': '2018-08-07',
            'EndTime': '12:00',
            'Status': 'Valid',
            "CanDelete":true,
            "CanPickUp":true,
        }];

        let timer = this.$timeout(500);
        this.timers.push(timer);
        return timer.then(() => {
            return this.showGuidAnimation().finally(() => {
                this.localStorageService.set('vehiclebookings-showed-guide', true);
                this.list = vehicleBookings;
                this.safeApply();
            });
        });
    },

    /**
     * Check if user has shown guide
     * @param list {IVehicleBooking[]}
     * @returns {boolean}
     */
    isShownedGuide(list) {
        return !this.localStorageService.get('vehiclebookings-showed-guide') && list.length > 0;
    },

    /**
     * Get my bookings when screen loaded
     * @returns {angular.IPromise<*>}
     */
    loadData() {
        return this.getMyBookings()
            .finally(this.$Loading.blockUI())
            .then((vehicleBookings) => {
                //show guide if list is not empty and the user hasn't yet show guide
                if (this.isShownedGuide(vehicleBookings)) {
                    return this.showGuide(vehicleBookings);
                } else {
                    this.list = vehicleBookings;
                    //scroll to top
                    return this.$timeout(() => {

                        //scroll to scrollTop when this list rendered
                        let scrollTop = this.$stateParams.scrollTop||0;
                        if(this.$stateParams.id) {
                            let item= this.$element.find("#booking-list-item-"+ this.$stateParams.id);
                            if(item.length>0) {
                                scrollTop = item.position().top;
                            }
                        }
                        this.$ionicScrollDelegate.$getByHandle('vehicle-bookings-scroller-handle').scrollTo(0, scrollTop);
                    });
                }
            }, this.$message.error);
    },

    refresh() {
        return this.getMyBookings().then((vehicleBookings) => {
            //show guide if list is not empty and the user hasn't yet show guide
            if (this.isShownedGuide(vehicleBookings)) {
                this.$scope.$broadcast('scroll.refreshComplete'); // Stop scroll to show guide
                return this.showGuide(vehicleBookings);
            } else {
                this.list = vehicleBookings;
                return this.$q.resolve();
            }
        }, this.$message.error);
    },

    doRefresh() {
        this.refresh()
            .then(() => {
                this.dataLoaded = true;
            })
            .finally(() => {
                this.$scope.$broadcast('scroll.refreshComplete');
            });
    }

}

angular.module('internal.vehiclebookings').controller('VehiclebookingsController', VehiclebookingsController);